




import Input from '@/types/Input.interface'
import Vue from 'vue'
interface CustomFieldModel {
    value: string; 
}
export default Vue.extend ({
    props: {
        //  the custom field we're creating an input for
        extension: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            model: {
                value: null
            },
            input: null
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(): void {
            //  Select a validation rule
            const rule = {
                phone: 'required|phone|max:20',
                // date: 'date_format:MM/dd/yyyy',
                text: 'max:75',
                number: 'decimal',
                dropdown: 'required'
            }[this.extension.type]

            //  Select an icon
            const icon = {
                phone: 'mdi-phone',
                date: 'mdi-calendar-month',
                text: 'mdi-text-shadow',
                number: 'mdi-pound-box',
                dropdown: 'mdi-format-list-bulleted'
            }[this.extension.type]

            //  Select the option type
            const type = {
                phone: 'PHONE',
                date: 'DATE',
                text: 'TEXT',
                number: 'TEXT',
                dropdown: 'SELECT'
            }[this.extension.type]

            //  Assemble the component label (selects have a special label)
            const label = type === 'SELECT' ? 'Select an option' : this.extension.name

            //  Push the extensions input
            this.input = {
                type: type,
                name: this.extension.name,
                label: label,
                options: this.extension.data || null,
                selected: this.extension.value,
                path: 'value',
                //appendIcon: 'mdi-plus-circle',
                prependIcon: icon,
                validate: rule
            }
        },
        reset(): void {
            this.model.value = null
            this.input = null
            this.$nextTick(() => {
                this.init()
            })
        },
        onChange(input: Input, val: string, model: CustomFieldModel): void {
            // Update the model
            this.model.value = val

            // Emit change event
            this.change(model)

            //  Create a list of 'types' that will be auto-submitted when changed
            const submitList = ['SELECT']

            //  Check if the input needs to be submitted
            const needsSubmit = submitList.includes(input.type)

            //  If the input needs to be submitted, do it!
            if (needsSubmit) this.submit(model)
        },
        submit(model: CustomFieldModel): void {
            this.$emit('submit', model.value)
        },
        change(model: CustomFieldModel): void {
            this.$emit('change', model.value)
        }
    }
})
